import { Dispatch, useEffect } from 'react';
import { IRequestApiCallStatus, TeamRequestAction } from '../team-request';
import { RevokeConsent, side, useAlertContext } from '../common';
import { compose as lcompose } from 'lodash/fp';
import { left, right, map as emap } from 'fp-ts/lib/Either';

export function useConfirmSubmitRequest({
  apiCallStatus,
  dispatchRequest,
}: {
  apiCallStatus: IRequestApiCallStatus;
  dispatchRequest: Dispatch<TeamRequestAction>;
}) {
  const { setAlert } = useAlertContext();

  useEffect(() => {
    lcompose(
      emap(() =>
        setAlert(a => ({
          ...a,
          title: 'CSOS Submit Request',
          message: () => <RevokeConsent handleClose={handleClose} />,
          okAction: false,
          cancelAction: false,
          isOpen: true,
        }))
      ),

      ({ type, apiCallStatus }) =>
        type === 'ConfirmSubmitRequest' && apiCallStatus === null
          ? right(void 0)
          : left(void 0)
    )(apiCallStatus);

    const handleClose = lcompose(
      side((a: boolean) => setAlert(b => ({ ...b, isOpen: false, isOk: a }))),
      side((a: boolean) =>
        a
          ? dispatchRequest({ type: 'SaveRequest', payload: void 0 })
          : dispatchRequest({ type: 'ConfirmSubmitRequest', payload: a })
      )
    );
  }, [apiCallStatus, dispatchRequest, setAlert]);
}
